import React, { ChangeEvent, FC, useState } from 'react';

import { TextInput } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import ActionButton from 'components/action-button';
import Dialog from 'components/dialog';
import { brandFont } from 'components/layout/brand-font';

const Text = styled.p``;
const Title = styled.h2`
  font: ${brandFont.headerOne};
  font-size: 1.6rem;
  text-align: center;
  margin: 0;
`;
const StyledButton = styled(ActionButton)`
  text-overflow: unset;
  padding: 0.75rem;
`;

interface IRealMealModel {
  isLoading?: boolean;
  onSave: (name: string) => void;
  onDismiss?: () => void;
}

const RealMealModal: FC<IRealMealModel> = ({ isLoading, onSave, onDismiss }) => {
  const { formatMessage } = useIntl();
  const [name, setName] = useState<string>('');

  const handleSave = () => {
    onSave(name);
  };

  return (
    <Dialog
      data-testid="real-meal-modal"
      showCloseButton={true}
      onDismiss={onDismiss}
      modalAppearanceEventMessage="Save Real Meal"
      bodyComponent={
        <>
          <Title>{formatMessage({ id: 'nameYourRealMeal' })}</Title>
          <Text>{formatMessage({ id: 'saveFavoriteOrderText' })}</Text>
          <TextInput
            aria-label={formatMessage({ id: 'orderName' })}
            data-testid="real-meal-text"
            label={formatMessage({ id: 'orderName' })}
            onChange={(event: ChangeEvent<HTMLInputElement>) => setName(event.currentTarget.value)}
            required
            type="text"
            value={name}
          />
        </>
      }
      actions={
        <StyledButton
          isLoading={isLoading}
          disabled={!name}
          allowFullScreen
          fullWidth
          onClick={handleSave}
          data-testid="real-meal-button"
        >
          {formatMessage({ id: 'saveRealMealOrderButton' })}
        </StyledButton>
      }
    />
  );
};

export default RealMealModal;
